
import React, { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { Grid } from '@mui/material';
import ProductUnitCreateView from '../../../components/inventory/setup/product_unit/ProductUnitCreateView';
import ProductUnitListView from '../../../components/inventory/setup/product_unit/ProductUnitListView';

const UnitCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.InventoryURL + 'inventory/product/unit/create/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <ProductUnitCreateView handleFormSuccess={handleFormSuccess} />
                </Grid>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <ProductUnitListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} results={data} error={error} loading={loading} />
                </Grid>
            </Grid>

        </Fragment>
    )
}

export default UnitCreateListView